<template>
  <div class="lead-event-list align-items-center"> 
    <div class="row position-relative" @click="selectEvent">
      <lead-event-item :lead-event="leadEvent" :full-width="true"></lead-event-item>
      <div class="controls position-absolute text-right" style="right: 15px; top: 10px; z-index: 10;">
        <a class="btn btn-sm btn-primary mb-2 " @click.stop="leadEventEdit = true">Edit</a>
        <a class="btn btn-sm btn-primary mb-2 " @click.stop="openPipeline">Pipeline</a>
        <a class="btn btn-sm btn-primary mb-2" @click.stop="leadEventMerge = true" v-if="canMerge && isTeamLead">Merge</a>
      </div>
    </div>
    <el-dialog
      title="Edit Event"
      width="800px"
      :visible.sync="leadEventEdit"
      v-if="leadEventEdit"
    >
      <edit-lead-event :lead-event="leadEvent" @onSave="onUpdate"></edit-lead-event>
    </el-dialog>
    <el-dialog
      title="Edit Pipeline"
      width="600px"
      :visible.sync="leadEventPipeline"
      v-if="leadEventPipeline"
    >
      <edit-pipeline :lead-event="leadEvent" @onSave="onUpdate"></edit-pipeline>
    </el-dialog>
    <el-dialog
      title="Merge Event"
      width="800px"
      :visible.sync="leadEventMerge"
      v-if="leadEventMerge && isTeamLead"
    >
      <lead-event-merge :selected-lead-event="leadEvent" :lead-id="leadId" @onMerged="onUpdate"></lead-event-merge>
    </el-dialog>
    <el-drawer
      :visible.sync="showWidgets"
      direction="rtl"
      size="40%"
    >
      <lead-event-details :lead-event="leadEvent" v-if="showWidgets"></lead-event-details>
    </el-drawer>
  </div>
</template>
<script>
import EditLeadEvent from '@/views/Widgets/LeadDetails/EditLeadEvent';
import EditPipeline from '@/views/Widgets/LeadDetails/EditPipeline';
import LeadEventMerge from '@/views/Widgets/LeadDetails/LeadEventMerge';
import { Tag, Drawer, Notification } from "element-ui";
import LeadEventDetails from '@/views/Widgets/LeadEventDetails/LeadEventDetails';
import LeadEventItem from '@/views/Widgets/LeadDetails/LeadEventItem.vue';
export default {
  components: {
    EditLeadEvent,
    EditPipeline,
    LeadEventMerge,
    [Tag.name]: Tag,
    [Drawer.name]: Drawer,
    [Notification.name]: Notification,
    LeadEventDetails,
    LeadEventItem,
  },
  props: {
    leadEvent: {
      type: Object,
      required: true,
    },
    canMerge: {
      required: true,
      type: Boolean,
    },
    leadId: {
      required: true,
    },
  },
  data() {
    return {
      leadEventEdit: false,
      leadEventPipeline: false,
      leadEventMerge: false,
      showWidgets: false,
    };
  },
  computed: {
    isTeamLead() {
      return this.$store.getters["auth/isTeamlead"];
    },
  },
  methods: {
    async onUpdate() {
      this.leadEventEdit = false;
      this.leadEventPipeline = false;
      this.leadEventMerge = false;
    },
    selectEvent() {
      if (this.leadEvent.is_data_needs_update) {
        this.openPipeline();
      } else {
        this.showWidgets = true;
      }
    },
    openPipeline() {
        let isValid = true;
        let errorMessage = '';

        // Check if event_date (or event_start which contains date) is present
        if (!this.leadEvent.event_start) {
            isValid = false;
            errorMessage = 'Event Date is required.';
        }

        // Check time for corporate events
        if (isValid && this.leadEvent.event_type === 'corporate') {
            // Check if start_time and end_time are present
            if (! this.leadEvent.event_start || ! this.leadEvent.event_end) {
                isValid = false;
                errorMessage = 'Start Time and End Time are required for Corporate events.';
            }
        }

        if (isValid) {
            this.leadEventPipeline = true;
        } else {
            Notification.error({
                title: 'Error',
                message: errorMessage + ' Please update event details.',
                type: 'error'
            });
            this.leadEventEdit = true;
        }
    }
  },
};
</script>
<style scoped>
.controls a {
    width: 70px;
}
.lead-event-list .controls {
  visibility: hidden;
}
.lead-event-list:hover .controls {
  visibility: visible;
}
</style>